/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'share-modal.accordion-button-label':
    '{entity, select, project {誰會收到每週專案更新？} goal {誰會收到每週目標更新？} other {誰會收到每週更新？}}',
  'share-modal.add-as-follower-checkbox-label': '新增為追蹤者',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {追蹤者會在摘要中收到目標的每週更新內容} goal {追蹤者會在摘要中收到目標的每週更新內容} other {追蹤者會在摘要中收到的每週更新內容}}',
  'share-modal.all-tab-label': '全部',
  'share-modal.contributors-tab-label': '參與者',
  'share-modal.followers-tab-label': '追蹤者',
  'share-modal.followers-title': '追蹤者',
  'share-modal.footer.access-level-disclaimer':
    '{entity, select, project {擁有工作區存取權的每個人都可以看到此專案。} goal {擁有工作區存取權的每個人都可以看到此目標。} other {擁有工作區存取權的每個人都可以看到。}}',
  'share-modal.footer.access-level-private-disclaimer': '{entity, select, project {私密專案} goal {私密目標} other {}}',
  'share-modal.footer.copy-link-button': '複製連結',
  'share-modal.footer.copy-link-button.copied-tooltip': '已複製！',
  'share-modal.footer.copy-link-button.tooltip':
    '{entity, select, project {複製專案連結} goal {複製目標連結} other {複製連結： }}',
  'share-modal.modal.user-picker.add-more-placeholder': '新增更多人員',
  'share-modal.share-button': '分享',
  'share-modal.share-title': '分享',
  'share-modal.user-item.can-edit-label': '可編輯',
  'share-modal.user-picker.placeholder': '搜尋和邀請使用者',
  'shareModal.followers-empty-state.default-title': '缺少重要的相關人員嗎？',
  'shareModal.followers-empty-state.goal-cta':
    '將他們新增為追蹤者或連接 Slack 或 MS Teams 頻道，確保他們在每月摘要中能取得目標的最新更新內容',
  'shareModal.followers-empty-state.project-cta':
    '將關鍵團隊和相關人員新增為追蹤者，讓追蹤者隨時掌握最新狀況。連接頻道以直接在聊天中分享更新。',
  'shareModal.followers-empty-state.project-title': '透過新增追蹤者來觸及更廣泛的受眾',
};
